import React from 'react';
import { Storefront, Buildings, ChartLineUp, ArrowRight, Check } from '@phosphor-icons/react';
import { usePersona, personas, PersonaId } from './PersonaContext';
const personaIcons = {
  sme: Storefront,
  accountant: Buildings,
  cfo: ChartLineUp
};
export function PersonaSelector() {
  const {
    persona,
    setPersona
  } = usePersona();
  const handleSelect = (id: Exclude<PersonaId, null>) => {
    setPersona(persona === id ? null : id);
    if (persona !== id) {
      setTimeout(() => {
        document.getElementById('pain')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
  };
  return <section id="persona" className="py-16 lg:py-24 bg-white border-b border-hairline" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-341">
          <p className="font-mono text-[11px] tracking-wider uppercase text-knight-orange mb-3" data-id="element-342">
            Step 01 / Tell us who you are
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal leading-tight mb-4" data-id="element-343">
            Knight works differently depending on who is reading this.
          </h2>
          <p className="text-base text-gray-600 leading-relaxed" data-id="element-344">
            Choose the one that fits. We will tailor what you see next so you
            are not wading through pages that do not apply to you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-5" data-id="element-345">
          {(Object.keys(personas) as Array<Exclude<PersonaId, null>>).map(id => {
          const p = personas[id];
          const Icon = personaIcons[id];
          const isActive = persona === id;
          return <button key={id} onClick={() => handleSelect(id)} className={`group text-left p-6 lg:p-7 rounded-md border transition-all duration-500 ease-out-expo relative ${isActive ? 'bg-near-black border-knight-orange text-white' : 'bg-white border-hairline hover:border-charcoal'}`} data-id="element-346">
                  {isActive && <div className="absolute top-4 right-4 w-6 h-6 rounded-full bg-knight-orange flex items-center justify-center" data-id="element-347">
                      <Check size={14} weight="bold" className="text-white" data-id="element-348" />
                    </div>}

                  <div className={`w-11 h-11 rounded-md flex items-center justify-center mb-5 transition-colors ${isActive ? 'bg-knight-orange/15' : 'bg-off-white'}`} data-id="element-349">
                    <Icon size={22} weight="duotone" className={isActive ? 'text-knight-orange' : 'text-charcoal'} data-id="element-350" />
                  </div>

                  <p className={`font-mono text-[10px] tracking-wider uppercase mb-2 ${isActive ? 'text-knight-orange' : 'text-gray-400'}`} data-id="element-351">
                    I am a
                  </p>
                  <h3 className={`text-xl font-heading font-bold mb-2 ${isActive ? 'text-white' : 'text-charcoal'}`} data-id="element-352">
                    {p.label}
                  </h3>
                  <p className={`text-xs mb-4 font-mono tracking-wide ${isActive ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-353">
                    {p.audience}
                  </p>
                  <p className={`text-sm leading-relaxed mb-5 ${isActive ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-354">
                    {p.description}
                  </p>
                  <div className={`inline-flex items-center text-sm font-semibold transition-all ${isActive ? 'text-knight-orange' : 'text-charcoal group-hover:text-knight-orange'}`} data-id="element-355">
                    {isActive ? 'Selected' : 'Show me what this looks like'}
                    <ArrowRight size={14} weight="regular" className="ml-1.5 transition-transform group-hover:translate-x-0.5" data-id="element-356" />
                  </div>
                </button>;
        })}
        </div>

        {persona && <div className="mt-8 max-w-3xl mx-auto text-center font-mono text-[11px] tracking-wider uppercase text-gray-500" data-id="element-357">
            Showing the path for /{' '}
            <span className="text-knight-orange" data-id="element-358">
              {personas[persona].shortLabel}
            </span>
          </div>}
      </div>
    </section>;
}